import type { IconProps } from '@src/components/icons/IconProps';

export function HomeIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="m3 10 9-7 9 7M5 9v12h5v-7h4v7h5V9" />
    </svg>
  );
}
